var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "about-us" },
        [
          _c(
            "el-container",
            { staticClass: "d-flex-column" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [_vm._v(" ")]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("h2", [_vm._v("Come join us")]),
                    _c("p", [
                      _vm._v(
                        "Want to be part of maren solutions, please click on the below Button to drop your resume "
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "btn-bg" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "drop-res",
                            attrs: {
                              size: "large",
                              round: "",
                              type: "warning"
                            },
                            on: {
                              click: function($event) {
                                _vm.dialogFormVisible = true
                              }
                            }
                          },
                          [
                            _vm._v("Drop your resume here "),
                            _c("i", {
                              staticClass: "pull-right icon-sort-arrow-right"
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("el-container", { staticClass: "d-flex-column" }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Walk us through your profile",
            visible: _vm.dialogFormVisible,
            width: "60%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "First name" } },
                        [
                          _c("el-input", {
                            staticClass: "form-control",
                            model: {
                              value: _vm.form.name,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Last name" } },
                        [
                          _c("el-input", {
                            staticClass: "form-control",
                            model: {
                              value: _vm.form.lastname,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "lastname", $$v)
                              },
                              expression: "form.lastname"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Phone number" } },
                        [
                          _c("el-input", {
                            staticClass: "form-control",
                            model: {
                              value: _vm.form.number,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "number", $$v)
                              },
                              expression: "form.number"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Alternative phone number" } },
                        [
                          _c("el-input", {
                            staticClass: "form-control",
                            model: {
                              value: _vm.form.alternativenumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "alternativenumber", $$v)
                              },
                              expression: "form.alternativenumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Email" } },
                        [
                          _c("el-input", {
                            staticClass: "form-control",
                            model: {
                              value: _vm.form.email,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "email", $$v)
                              },
                              expression: "form.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Attachment" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                drag: "",
                                action:
                                  "https://jsonplaceholder.typicode.com/posts/"
                              }
                            },
                            [
                              _c("i", { staticClass: "icon-attachment" }),
                              _c("span", { staticClass: "el-upload__text" }, [
                                _vm._v("Attach your resume")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "", size: "large" },
                  on: { click: _vm.onSubmit }
                },
                [_vm._v("Submit")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/static/Careers.vue?vue&type=template&id=0589388e&
// module id = 578
// module chunks = 8